
export const SET_NAV_HEADER = 'SET_NAV_HEADER';
export const setNavHeader = (showBackBtn, title) => (
    {
        type: SET_NAV_HEADER,
        showBackBtn,
        title
    }
)




// WEBPACK FOOTER //
// ./src/App/MainClient/Navbar/actions.js